import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import { sortSearchParam } from "@src/common/service/searchExecuter"
import Chart from "chart.js/auto";

$(function () {
    window.Chart = Chart;
});

createInertiaApp({
    resolve: name => resolveComponent(name),
    setup({ el, App, props }) {
        if (props.initialPage.component.includes('SearchJob')) {
            // クエリパラメータ整理用の処理を検索結果画面に限定
            const currentUrl = window.location.href;
            const pathName = window.location.pathname;
            props.initialPage.url = pathName + sortSearchParam(currentUrl);
        }
        createRoot(el).render(<App {...props} />)
    },
})

/**
 * @param {string} name
 */
function resolveComponent(name) {
    const pcPrefix = 'pc::';

    if (name.startsWith(pcPrefix)) {
        return require(`./pages/pc/${name.replace(pcPrefix, '')}`);
    } else {
        return require(`./pages/${name}`);
    }
}
